import React, { Component } from 'react';
import {Switch, Route, withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import TasksList from './components/TasksList';
import Avatar from '../Avatar';
import EditOptions from '../EditOptions';
import AddTaskModal, {EditTaskModal} from '../AddTaskModal';
import {DropDown, InputField} from '../InputForms'
import {Icon, IconTypes, TextButton, TextButtonTypes} from '../Buttons'
import Spinner from '../Spinner';
import ConfirmationModal from '../ConfirmationModal';
import styles from './style.css';
import CharLists from './components/CharLists'
import LogoUploadModal from './components/LogoUpload'
import {EditCategoriesButton} from '../AddCategoryModal'

@inject('store')
@observer
class _AgentInfo extends Component {
    render() {
        const agents = this.props.store.agents
        const fetching = this.props.store.agentsFetching
        return (
            <div className={styles.agentInfo}>
              <Switch>
                <Route path='/agents/:id' render={({match}) => {
                  const agent = agents.find((a) => (a.id === Number.parseInt(match.params.id, 10)))
                  return agent
                    ? <Agent agent={agent} onEditAgent={this.props.onEditAgent(agent)}/>
                    : <NoAgent fetching={fetching}/>
                }}/>
                <Route exact path='/agents' component={NoAgent}/>
              </Switch>
            </div>
        );
    }
}

const NoAgent = inject('localizationStore')(observer(
    ({localizationStore, fetching}) => {
        const locale = localizationStore.locale
        return (
            <div className={styles.noSelectedAgent}>
                {fetching ?
                    <Spinner/>
                    :
                    <span>{locale.no_agent}</span>
                }
            </div>
        );
}))

@inject('store', 'notificationsStore', 'localizationStore')
@observer
class Agent extends Component {
    state = {
        disabled: true,
        openedModal: false,
        id: null,
        name: '',
        status: '',
        confirmationModalInfo: null
    }

    onNameChange = (event) => {
        this.setState({name: event.target.value})
    }

    onDeleteClick = () => {
        this.setState({confirmationModalInfo: {
            question: this.props.localizationStore.locale.remove_agent_question,
            applyAction: () => this.props.store.deleteAgentRequest(this.state.id),
            cancelAction: () => this.setState({confirmationModalInfo: null})
        }})
    }

    onCloseModal = () => {
        this.setState({openedModal: false, modalData: null})
    }

    onEditClick = () => {
        this.props.onEditAgent()
    }

    onAddTaskClick = () => {
        this.setState({openedModal: true, modalData: {}})
    }

    onEditTaskClick = (task) => {
        this.setState({openedModal: true, modalData: {task}})
    }

    onAgentStatusChange = (event) => {
        this.setState({status: event.target.value})
        this.props.store.getAgent(this.state.id).setStatus(event.target.value)
    }
    
    onAvatarChange = (image) => {
        this.props.agent.changeAvatarRequest(image)
    }

    onAddTaskSuccess = () => {
        this.onCloseModal()
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.agent.id !== prevState.id) {
            return {
                disabled: true,
                id: nextProps.agent.id,
                name: nextProps.agent.description,
                status: nextProps.agent.status
            }
        }
        return null
    }
    render() {
        const {agent, store, localizationStore} = this.props
        const locale = localizationStore.locale
        const statusValues = [
            {value: 'ACTIVE', label: locale.active, disabled: true},
            {value: 'BEING_TESTED', label: locale.being_tested},
            {value: 'INACTIVE', label: locale.inactive}
        ]

        const sameUser = agent.userId === store.currentUserID
        const editable = store.isAdministrator() || sameUser

        const avatarProps = {
            avatar: agent.avatar,
            size: 90,
            borderWidth: 2,
            onChange: sameUser ? this.onAvatarChange : undefined
        }

        return (
            <div className={styles.agent}>
                <div className={styles.general}>
                    <Avatar {...avatarProps} />
                    <div className={styles.mainInfo}>
                        <div className={styles.name}>
                            <InputField style={styles.nameInputBox}
                                        required
                                        value={this.props.agent.description}
                                        onChange={this.onNameChange}
                                        disabled={true}
                            />
                            <EditOptions disabled={!editable} onClick={this.onEditClick} />
                        </div>
                        <div className={styles.status}>
                            <DropDown style={styles.statusSelection}
                                      name='status'
                                      options={statusValues}
                                      value={this.state.status}
                                      onChange={this.onAgentStatusChange}
                                      disabled={!editable}
                                      viewedByAdministrator={store.isAdministrator()}
                            />
                        </div>
                        <TextButton
                          text={locale.upload_logo}
                          type={TextButtonTypes.primary}
                          onClick={() => this.setState({uploadLogoModal: true})}
                          disabled={!editable} />
                        {this.state.uploadLogoModal
                          ? <LogoUploadModal agent={this.props.agent} onClose={() => this.setState({uploadLogoModal: false})}/>
                          : null}
                        <EditCategoriesButton agent={agent}>
                            {onClick => <TextButton
                              text={locale.set_categories}
                              type={TextButtonTypes.primary}
                              onClick={onClick}
                              disabled={!editable} />}
                        </EditCategoriesButton>
                    </div>
                </div>
                <Icon disabled={!editable} type={IconTypes.delete} style={styles.deleteIcon} onClick={this.onDeleteClick} confirmationNeeded={true} />
                <div className={styles.tasksHeader}>
                    <span>{locale.tasks}</span>
                    <Icon type={IconTypes.add} onClick={this.onAddTaskClick} disabled={!editable}/>
                </div>
                <TasksList agentId={agent.id} editable={editable} onEditTask={this.onEditTaskClick} />
                <CharLists agent={agent} editable={editable} localizationStore={localizationStore} />
                {this.state.openedModal
                    ? this.state.modalData.task
                        ? <EditTaskModal agent={this.props.agent} task={this.state.modalData.task} onClose={this.onCloseModal} onSuccess={this.onAddTaskSuccess}/>
                        : <AddTaskModal agent={this.props.agent} onClose={this.onCloseModal} onSuccess={this.onAddTaskSuccess} />
                    : null
                }

                {this.state.confirmationModalInfo !== null ?
                    <ConfirmationModal agent={this.props.agent}
                                       question={this.state.confirmationModalInfo.question}
                                       onApply={this.state.confirmationModalInfo.applyAction}
                                       onCancel={this.state.confirmationModalInfo.cancelAction}
                    />
                    : null
                }
            </div>
        );
    }
}

const AgentInfo = withRouter(_AgentInfo)

export default AgentInfo;



// WEBPACK FOOTER //
// ./src/components/AgentInfo/index.js